
//import storage from 'redux-persist/lib/storage';
const loginInt = {
    token: '',
    isLoggedIn: false,
    isInitialized: false,
    user: null,
    userLoginDetials: {},
    newUserLoginDetails:{},
    digitokenno:""
    

}
function LoginReducer(state = loginInt, action) {
    // //console.log('action',action.payload );
    switch (action.type) {



      


      
        case "LOGIN_DETAILS": {
            const { isLoggedIn, user, token, userLoginDetials,newUserLoginDetails } = action.payload;
            return {
                ...state,
                isLoggedIn,
                isInitialized: true,
                token,
                user,
                userLoginDetials,
                newUserLoginDetails,
                
            };
        }
        case "LOGOUT": {
            return {
                ...state,
                isLoggedIn: false,
                token: '',
                user: ''
            };
        }
        
        default:
            return state;
        // case "USER_LOGOUT": {
        //     storage.removeItem('persist:root');
        //     break;
        // }
        // default: {
        //     return { ...state };
        // }

        // case "LOGIN": {
        //     const { user } = action.payload;
        //     return {
        //         ...state,
        //         isLoggedIn: true,
        //         user
        //     };

        // }
    }

}
export default LoginReducer;
